// frontend/src/components/MlPredict/MlPredictResult.tsx

import React from 'react';
import type { ModelSchema, PredictionResponse } from '../../services/mlModels.service';

interface Props {
  prediction: PredictionResponse;
  schema: ModelSchema;
}

// ============================================================
// Regras de interpretação
// ============================================================
const THRESHOLD = 0.5;

function calcularRisco(prob: number): { label: string; classe: string } {
  if (prob < 0.1) return { label: 'Baixo', classe: 'risk-low' };
  if (prob < 0.5) return { label: 'Médio', classe: 'risk-medium' };
  return { label: 'Alto', classe: 'risk-high' };
}

export const MlPredictResult: React.FC<Props> = ({ prediction, schema }) => {
  const prob = prediction.predictions[0] ?? 0;
  const probPercent = (prob * 100).toFixed(2);
  const classe = prob >= THRESHOLD ? schema.target_name : `não-${schema.target_name}`;
  const risco = calcularRisco(prob);

  return (
    <div className="predict-result">
      <h3>🎯 Resultado da Predição</h3>

      <div className="result-grid">
        <div className="result-card">
          <div className="result-icon">📊</div>
          <div className="result-value">{probPercent}%</div>
          <div className="result-label">Probabilidade</div>
        </div>

        <div className="result-card">
          <div className="result-icon">🎯</div>
          <div className="result-value">{classe}</div>
          <div className="result-label">
            Classificação (threshold {(THRESHOLD * 100).toFixed(0)}%)
          </div>
        </div>

        <div className={`result-card ${risco.classe}`}>
          <div className="result-icon">💡</div>
          <div className="result-value">{risco.label}</div>
          <div className="result-label">Risco</div>
        </div>
      </div>

      <div className="result-footnote">
        Faixas: &lt;10% Baixo · 10–50% Médio · ≥50% Alto
      </div>

      <div className="result-meta">
        <span>
          Modelo: <strong>{schema.model_name}</strong>
        </span>
        <span>
          Dataset: <strong>{schema.dataset_name}</strong>
        </span>
        <span>
          Versão: <strong>{schema.pipeline_version}</strong>
        </span>
        <span>
          Alvo: <strong>{schema.target_name}</strong>
        </span>
      </div>
    </div>
  );
};